import {getAxios} from './axios';
import {addAuthTokenData} from './member';

export function getWishlists(params) {
    let axios = getAxios();

    return axios.request({
        url: '/wishlists/',
        method: 'get',
        params: addAuthTokenData(params)
    });
}



// WEBPACK FOOTER //
// ./src/backend-helpers/wishlists.js